<div class="h-dvh w-full flex flex-col">
  <div *ngIf="_tools.bSmallScreen" class="px-4 pt-4 bg-[var(--main)]">
    <div class="rounded-xl bg-[var(--main-light)] flex items-center justify-between w-full p-4 z-50">
      <div class="relative inline-block h-12">
        <ng-container *ngIf="logo != '' && logo != null">
          <img *ngIf="_theme.isDarkTheme" src="/img/logos/DARK_{{ logo }}" alt="" class="h-full object-cover" />
          <img *ngIf="!_theme.isDarkTheme" src="/img/logos/{{ logo }}" alt="" class="h-full object-cover" />
        </ng-container>   
        <img *ngIf="logo == '' || logo == null" src="/img/logo.png" alt="" class="h-full object-cover" />
      </div>
      <div class="relative size-12 rounded-full overflow-hidden">
        <a [routerLink]="[lMenu[lMenu.length - 1].path]" [routerLinkActive]="['active']"
          class="size-full font-black text-2xl flex items-center justify-center profil-circle overflow-hidden relative">
          {{ oLogUser.login_Nom.charAt(0)
          }}{{ oLogUser.login_Prenom.charAt(0) }}
          <img *ngIf="oLogUser.login_Photo != '' && oLogUser.login_Photo != null"
            [src]="_tools.getPhotoPath(oLogUser.login_Photo)" onerror="this.onerror=null; this.remove();" class="absolute object-cover object-center" />
        </a>
      </div>
    </div>
  </div>
  <mat-drawer-container class="flex-1" [autosize]="true">
    <mat-drawer *ngIf="!_tools.bSmallScreen" [mode]="mode" [opened]="opened" class="main-drawer py-6 pl-6">
      <div class="size-full flex gap-6">
        <div class="h-full bg-[var(--main-light)] rounded-2xl p-5 flex flex-col items-center justify-between">
          <div class="relative inline-block w-12">
            <ng-container *ngIf="logo != '' && logo != null">
              <img *ngIf="_theme.isDarkTheme" src="/img/logos/DARK_{{ logo }}" alt="" />
              <img *ngIf="!_theme.isDarkTheme" src="/img/logos/{{ logo }}" alt="" />
            </ng-container>
            <img *ngIf="logo == '' || logo == null" src="/img/logo.png" alt="" />
          </div>
          <div class="flex flex-col gap-2">
            @for (m of lMenu; track $index) {
            @if (getSublinksActive(m).length > 1 || m.path == 'account') {
            <button (click)="activeMenu = $index" class="card-link size-12" [matTooltip]="m.title"
              matTooltipPosition="right" [ngClass]="activeMenu == $index ? 'active' : ''">
              <mat-icon>{{ m.icon }}</mat-icon>
              <!-- <div class="text-xs">{{ m.title }}</div> -->
            </button>
            } @else if (getSublinksActive(m).length > 0) {
            <button [routerLink]="m.path + '/' + getSublinksActive(m)[0].path"
              [ngClass]="activeMenu == $index ? 'active' : ''" (click)="activeMenu = $index" class="card-link size-12"
              [matTooltip]="getSublinksActive(m)[0].title" matTooltipPosition="right">
              <mat-icon>{{ getSublinksActive(m)[0].icon }}</mat-icon>
              <!-- <div class="text-xs">{{ getSublinksActive(m)[0].title }}</div> -->
            </button>
            }
            }
          </div>
          <div class="size-12"></div>
        </div>

        @if (activeMenu != null) {
        @if ((getSublinksActive(lMenu[activeMenu]).length > 1 || activeMenu == lMenu.length - 1))
        {
        <div class="relative rounded-2xl w-[280px] border border-[var(--border)] bg-[var(--main)]">
          <div>
            <div class="p-4 border-b border-[var(--border)]">
              <h1 class="text-center font-black leading-7">{{ societe }}</h1>
            </div>

            @if (activeMenu == lMenu.length - 1) {
            <div class="size-full flex items-center justify-center p-4">
              <div class="font-black text-2xl profil-circle size-20 rounded-full flex items-center justify-center overflow-hidden relative">
                {{ oLogUser.login_Nom.charAt(0)
                }}{{ oLogUser.login_Prenom.charAt(0) }}
                <img *ngIf="
                        oLogUser.login_Photo != '' && oLogUser.login_Photo != null
                      " [src]="_tools.getPhotoPath(oLogUser.login_Photo)"
                  onerror="this.onerror=null; this.remove();" class="absolute object-cover object-center" />
              </div>
            </div>
            <h4 class="text-[var(--text-light)] font-black text-center my-4">
              {{ oLogUser.login_Nom }} {{ oLogUser.login_Prenom }}
            </h4>
            }
          </div>

          <div class="flex flex-col gap-2 p-4">
            <div class="text-sm font-medium leading-5 text-[var(--text-lightest)]">
              {{ lMenu[activeMenu].title }}
            </div>
            @for (l of getSublinksActive(lMenu[activeMenu]); track $index) {
            <a *ngIf="showMenuLink(l)" [routerLink]="lMenu[activeMenu].path + '/' + l.path"
              [routerLinkActive]="['active']" class="rounded-link text-[var(--text)]">
              <mat-icon>{{ l.icon }}</mat-icon>
              <div class="flex-1 text-sm">
                {{ l.title }}
              </div>
              <span *ngIf="l.bNew" class="alert-sm alert-info popup-animation">New</span>
              <ng-container *ngIf="
                      l.path == 'incidents' && _notifs.getNewIncidents()
                        | async as incidents
                    ">
                <span *ngIf="incidents.length > 0"
                  class="flex items-center justify-center size-5 rounded-full text-sm bg-[var(--error)] text-[var(--error-color)] font-semibold popup-animation">{{
                  incidents.length }}</span>
              </ng-container>
              <ng-container *ngIf="l.path == 'documents' && _notifs.getNewDocuments()">
                <span *ngIf="_notifs.getNewDocuments().length > 0"
                  class="flex items-center justify-center size-5 rounded-full text-sm bg-[var(--error)] text-[var(--error-color)] font-semibold popup-animation">{{
                  _notifs.getNewDocuments().length }}</span>
              </ng-container>
            </a>
            }
          </div>
          @if (activeMenu == lMenu.length - 1) {
          <div class="p-4 mt-4">
            <button (click)="logOutProcess()" class="btn btn-warn w-full">
              <mat-icon>logout</mat-icon> Se déconnecter
            </button>
          </div>
          }
          <button (click)="activeMenu = null" matTooltip="Masquer le panneau latéral" matTooltipPosition="right"
            class="absolute bottom-4 right-4 rounded-full bg-[var(--main-light)] size-10 flex items-center justify-center">
            <mat-icon class="text-[var(--text)]">chevron_left</mat-icon>
          </button>
        </div>
        }
        }
      </div>
    </mat-drawer>
    <mat-drawer-content [@routeAnimation]="prepareRoute(o)">
      <div class="size-full">
        <router-outlet #o="outlet"></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
  <div *ngIf="_tools.bSmallScreen" class="px-4 pb-4 bg-[var(--main)] w-full">
    <div class="mobile-menu rounded-xl p-2 bg-[var(--main-light)]"
      [ngClass]="bOpenMobile ? 'opened z-50' : 'overflow-hidden'">
      <ng-container *ngFor="let m of getGlobalsActive(); let idx = index">
        <div class="p-1">
          @if (getSublinksActive(m).length > 1 || m.path == 'account') {
          <a [routerLink]="[m.path]" [routerLinkActive]="['active']" class="card-link flex-1">
            <mat-icon>{{ m.icon }}</mat-icon>
            <div class="text-xs">{{ m.title }}</div>
          </a>
          } @else if (getSublinksActive(m).length > 0) {
          <a [routerLink]="m.path + '/' + getSublinksActive(m)[0].path" [routerLinkActive]="['active']"
            class="card-link flex-1">
            <mat-icon>{{ getSublinksActive(m)[0].icon }}</mat-icon>
            <div class="text-xs">{{ getSublinksActive(m)[0].title }}</div>
          </a>
          }
        </div>
        @if (idx == 2 && getGlobalsActive().length > 4) {
        <div class="size-full flex items-center justify-center">
          <button (click)="bOpenMobile = !bOpenMobile"
            class="size-10 rounded-full flex items-center justify-center bg-[var(--primary)] text-[var(--primary-color)]">
            <mat-icon *ngIf="bOpenMobile == false">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="bOpenMobile == true">keyboard_arrow_down</mat-icon>
          </button>
        </div>
        }
      </ng-container>
    </div>
  </div>
</div>

<app-window-host></app-window-host>
<app-window-bar></app-window-bar>
